export const appSupportedLanguages = [
  // English - United States
  {
    code: "en",
    title: "English",
    country: "us",
  },
  // French - France
  {
    code: "fr",
    title: "Français",
    country: "fr",
  },
  // German - Germany
  {
    code: "de",
    title: "Deutschland",
    country: "de",
  },
  // Spanish - Spain
  {
    code: "es",
    title: "Espagne",
    country: "es",
  },
  // Finnish - Finland
  {
    code: "fi",
    title: "Suomalainen",
    country: "fi",
  },
  // Hungarian - Hungary
  {
    code: "hu",
    title: "Magyar",
    country: "hu",
  },
  // Indonesian - Indonesia
  {
    code: "id",
    title: "bahasa Indonesia",
    country: "id",
  },
  // Malay - Malaysia
  {
    code: "ms",
    title: "Melayu",
    country: "ms",
  },
  // Dutch - Netherlands
  {
    code: "nl",
    title: "Nederlands",
    country: "nl",
  },
  // Polish - Poland
  {
    code: "pl",
    title: "Polski",
    country: "pl",
  },
  // Portuguese - Portugal
  {
    code: "pt",
    title: "Português",
    country: "pt",
  },
  // Romanian - Romania
  {
    code: "ro",
    title: "Română",
    country: "ro",
  },
  // Slovak - Slovakia
  {
    code: "sk",
    title: "slovenský",
    country: "sk",
  },
  // Swedish - Sweden
  {
    code: "sv",
    title: "svenska",
    country: "sv",
  },
  // Thai - Thailand
  {
    code: "th",
    title: "แบบไทย",
    country: "th",
  },
  // Turkish - Turkey
  {
    code: "tr",
    title: "Türkçe",
    country: "tr",
  },
  // Vietnamese - Vietnam
  {
    code: "vi",
    title: "Tiếng Việt",
    country: "vi",
  },
  // Chinese Simplified - China
  {
    code: "zh",
    title: "简体中文",
    country: "zh",
  },
  // Kazakh - Kazakhstan
  {
    code: "kk",
    title: "Қазақ тілі",
    country: "kz",
  },
  // Azerbaijani - Azerbaijan
  {
    code: "az",
    title: "Azərbaycanca",
    country: "az",
  },
  // Norwegian - Norway
  {
    code: "no",
    title: "Norsk",
    country: "no",
  },
  // Italian - Italy
  {
    code: "it",
    title: "Italiano",
    country: "it",
  },
  // Russian - Russia
  {
    code: "ru",
    title: "Русский",
    country: "ru",
  },
  // Czech - Czech Republic
  {
    code: "cs",
    title: "Čeština",
    country: "cz",
  },
  // Bengali - Bangladesh
  {
    code: "bn",
    title: "বাংলা",
    country: "bd",
  },
  // Hindi - India
  {
    code: "hi",
    title: "हिन्दी",
    country: "in",
  },
  // Arabic - Egypt
  {
    code: "ar",
    title: "العربية",
    country: "eg",
  },
  // Ukrainian - Ukraine
  {
    code: "uk",
    title: "Українська",
    country: "ua",
  },
  // Greek - Greece
  {
    code: "el",
    title: "Ελληνικά",
    country: "gr",
  },
  // Urdu - Pakistan
  {
    code: "ur",
    title: "اردو",
    country: "pk",
  },
  // Danish - Denmark
  {
    code: "da",
    title: "dansk",
    country: "da",
  },
  // Japanese - Japan
  {
    code: "ja",
    title: "日本語",
    country: "ja",
  },
  // Korean - South Korea
  {
    code: "ko",
    title: "한국인",
    country: "ko",
  },
];
